import React from 'react';
import DropdownItem from './DropdownItem';
import './DropdownList.css';

const DropdownList = ({ items, selectedIndex, onItemOver, onItemClick }) => (
  <div className="DropdownList">
    {
      items.map((user, index) => (
        <DropdownItem
          key={user.id}
          user={user}
          selected={index === selectedIndex}
          onMouseOver={() => onItemOver(index)}
          onClick={onItemClick}
        />
      ))
    }
  </div>
);

export default DropdownList;



// WEBPACK FOOTER //
// ./src/components/SearchBox/DropdownList.jsx